import { createFileRoute } from '@tanstack/react-router';
import { EmpresaPerfilPage, lerBuscaEmpresa } from '@/components/empresa-perfil';

export const Route = createFileRoute('/_app/configuracoes/empresa')({
  validateSearch: (bruto: Record<string, unknown>) => lerBuscaEmpresa(bruto),
  component: EmpresaRota,
});

function EmpresaRota() {
  return <EmpresaPerfilPage busca={Route.useSearch()} />;
}
